// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2WIw2","avatar":"Item_avatar__2p-ye","man":"Item_man__1B79w","position":"Item_position__wRuWn"};